import classnames from "classnames";
import React from "react";
import Modal from "react-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./generic-modal.css";

interface GenericModalProps {
    children: JSX.Element;
    isOpen: boolean;
    onAfterOpen?: () => void;
    onClose: () => void;
    className?: string;
    overlayClassName?: string;
    fullscreen?: boolean;
    closable?: boolean;
    noScroll?: boolean;
}

function GenericModal({
    children,
    isOpen,
    onAfterOpen,
    onClose,
    className,
    overlayClassName,
    fullscreen = false,
    closable = true,
    noScroll = true,
}: GenericModalProps): null | JSX.Element {
    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    return (
        <Modal
            appElement={appElement}
            className={classnames(styles.modal, className, { [styles.fullscreen]: fullscreen })}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onClose}
            overlayClassName={classnames(styles.overlay, overlayClassName)}
            shouldCloseOnOverlayClick={closable}
            shouldCloseOnEsc={closable}
            bodyOpenClassName={noScroll ? "no-scroll" : ""}
        >
            {closable && (
                <div className={styles.closeContainer}>
                    <CloseButton onClick={onClose} />
                </div>
            )}
            {children}
        </Modal>
    );
}

export default GenericModal;
